import { useQuery } from 'react-query';
import { enforceMFAOtp } from '../apiCalls';
import { QueryKey } from './QueryKeys';

const useEnforceMFAOtp = (apiEnvironment, mfaToken, enabled, onSuccess) => {
	const { data } = useQuery(
		[QueryKey.GET_MFA_OTP, apiEnvironment, mfaToken],
		enforceMFAOtp,
		{
			enabled,
			onSuccess,
		}
	);

	return {
		isError: data?.name === 'AxiosError',
		data: data?.name === 'AxiosError' ? null : data,
		// data will be error object if there's an error
		error: data,
	};
};

export default useEnforceMFAOtp;
